module.exports = __webpack_public_path__ + "images/help/icon-twr54@2x-c183a928c0a955c76992dfa0e8908f3f.png";